<template>
  <article>
    <h3>Typing Assistance:</h3>
    <ul role="menu">
      <li role="menuitem">
        <button
          @click="handleOnClick"
          @keypress.enter="handleOnClick"
          class="accessibility-text-helper-dropdown-button"
          id="view-total-text"
          role="button"
          tabindex="0"
        >
          Text to type
        </button>
      </li>
      <li role="menuitem">
        <button
          @click="handleOnClick"
          @keypress.enter="handleOnClick"
          class="accessibility-text-helper-dropdown-button"
          id="view-completed-text"
          role="button"
          tabindex="0"
        >
          Completed text
        </button>
      </li>
      <li role="menuitem">
        <button
          @click="handleOnClick"
          @keypress.enter="handleOnClick"
          class="accessibility-text-helper-dropdown-button"
          id="view-incomplete-text"
          role="button"
          tabindex="0"
        >
          Remaining text to type
        </button>
      </li>
    </ul>
  </article>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'AccessibilityTextHelperDropdown',
  computed: {
    ...mapState('accessibility', {
      currentKeyboardingSegment: state => state.currentKeyboardingSegment,
      totalKeyboardingSegment: state => state.totalKeyboardingSegment
    }),
    ...mapState('activity', ['data'])
  },
  methods: {
    ...mapMutations('accessibility', [
      'setCurrentKeyboardingSegment',
      'setTotalKeyboardingSegment'
    ]),
    ...mapMutations('application', ['setModal']),
    handleOnClick(event) {
      let heading = '';
      let text = '';

      switch (event.target.id) {
        case 'view-completed-text':
          heading = 'Completed text';
          text = this.transformWhiteSpace(this.currentKeyboardingSegment);
          break;
        case 'view-incomplete-text':
          heading = 'Remaining text to type';
          text = this.transformWhiteSpace(this.getRemainingText());
          break;
        case 'view-total-text':
          heading = 'Text to type';
          text = this.transformWhiteSpace(this.getTotalText());
      }
      this.setModal({
        type: 'helperText',
        data: { heading, text }
      });
    },
    getRemainingText() {
      return this.getTotalText().slice(this.currentKeyboardingSegment.length);
    },
    getTotalText() {
      if (this.totalKeyboardingSegment) return this.totalKeyboardingSegment;

      const blinkingCursorTextEls = document.querySelectorAll('.blinking-cursor-text');

      if (blinkingCursorTextEls.length) {
        const filteredBlinkingCursorTextEls = Array.from(blinkingCursorTextEls).filter(el => {
          return !el.classList.contains('text-completed') && el.querySelector('[role="input"]');
        });

        let currentBlickingCursorTextContainer = filteredBlinkingCursorTextEls.length
          ? filteredBlinkingCursorTextEls[0]
          : blinkingCursorTextEls[0];

        return currentBlickingCursorTextContainer.getAttribute('data-text');
      }

      return '';
    },
    transformWhiteSpace(text) {
      const isSpacebarActivity = this.data.type === 'Spacebar';
      return text.replace(isSpacebarActivity ? /\s/g : /^\s|\s$/g, '&nbsp;');
    }
  },
  mounted() {
    this.setCurrentKeyboardingSegment('');
  },
  destroyed() {
    this.setTotalKeyboardingSegment('');
  }
};
</script>

<style lang="scss" scoped>
article {
  background: white;
  box-shadow: var(
    --ds-shadow-overlay,
    0 0 0 1px rgba(9, 30, 66, 0.08),
    0 2px 10px rgba(9, 30, 66, 0.08),
    0 0 20px -4px rgba(9, 30, 66, 0.31)
  );
  padding: 16px;

  h3 {
    margin: 0px 0px 8px 0px;
  }

  ul {
    list-style: none;
    margin: 0px;
    padding: 0px;

    li {
      button {
        color: black;
        display: block;
        padding: 4px;
        background: white;
        border: 2px solid black;
        border-radius: 4px;
        margin: 8px 0px;
        width: 100%;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
